export const environment = {
  production: false,
  firebase: {
    projectId: "dagata-lom-test",
    appId: "1:59165020287:web:1167657f2817476bcf6f4a",
    storageBucket: "dagata-lom-test.firebasestorage.app",
    apiKey: "AIzaSyB0_-7hEmacOuVwdVyZgxrhj9_42-n-ecs",
    authDomain: "dagata-lom-test.firebaseapp.com",
    messagingSenderId: "59165020287"
  }
};
